import { environment } from '../../../environments/environment';

export const FEATURE_FLAGS = {
  showDevelopmentTools: isLocalEnvironment(environment.name),
} as const;

function isLocalEnvironment(name: string): boolean {
  return name === 'local';
}
